import React, { useMemo } from 'react';
import styles from './TournamentSparks.module.css';

const SPARK_COUNT = 16;

/**
 * Летящие искры для featured-карточки турнира.
 * Зелёные искры в общем стиле InterWorld.
 */
const TournamentSparks = () => {
  const sparks = useMemo(
    () =>
      Array.from({ length: SPARK_COUNT }, (_, i) => ({
        id: i,
        left: Math.random() * 92 + 4,
        bottom: Math.random() * 25,
        size: 5 + Math.random() * 7,
        duration: 4 + Math.random() * 6,
        delay: -Math.random() * 8,
        drift: (Math.random() - 0.5) * 70,
      })),
    []
  );

  return (
    <div className={styles.sparks} aria-hidden="true">
      {sparks.map((s) => (
        <span
          key={s.id}
          className={styles.spark}
          style={{
            left: `${s.left}%`,
            bottom: `${s.bottom}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
            '--drift': `${s.drift}px`,
          }}
        />
      ))}
    </div>
  );
};

export default TournamentSparks;